function invalidFields(form) {
  const fields = new Map();
  for (const input of form.querySelectorAll("input")) {
    if (input.willValidate && !input.validity.valid) {
      const field = input.closest(".nested_choice, .choice_field, .form_field") || input.closest(".checkbox_field");
      if (!fields.has(field)) {
        fields.set(field, input.validity.customError ? input.validationMessage : field.getAttribute("data-error") || input.validationMessage);
      }
    }
  }
  return fields;
}

function errorMessage(text) {
  const message = document.createElement("p");
  message.className = "field_error";
  message.innerHTML = '<i class="fa-solid fa-circle-exclamation"></i>';
  message.append(text);
  return message;
}

function showField(field) {
  field.scrollIntoView({block: "center", behavior: "smooth"});
  field.querySelector("input:not([disabled])")?.focus({preventScroll: true});
}

function displayErrors(form) {
  const fields = invalidFields(form), summary = form.querySelector(".form_errors");
  form.querySelectorAll(".has_error").forEach(field => field.classList.remove("has_error"));
  form.querySelectorAll(".field_error").forEach(message => message.remove());
  summary.innerHTML = `<p><i class="fa-solid fa-triangle-exclamation"></i>Votre compte n'est pas encore créé : ` +
    `${fields.size > 1 ? `${fields.size} réponses sont manquantes ou incorrectes` : "une réponse est manquante ou incorrecte"}</p><ul></ul>`;
  for (const [field, text] of fields) {
    const heading = field.querySelector(":scope > h4"), item = document.createElement("li"), link = document.createElement("button");
    field.classList.add("has_error");
    if (heading) {
      heading.after(errorMessage(text));
    } else {
      field.append(errorMessage(text));
    }
    link.type = "button";
    link.textContent = text;
    link.addEventListener("click", () => showField(field));
    item.append(link);
    summary.querySelector("ul").append(item);
  }
  summary.classList.toggle("hidden", fields.size === 0);
  return fields.size === 0;
}

function syncDepartments(form) {
  const mainDepartment = form.querySelector("input[name='user_profile[main_department]']:checked"),
    hasOtherDepartment = form.querySelector("#has_other_department").checked;
  for (const input of form.querySelectorAll("input[name='user_profile[other_department]']")) {
    input.disabled = !hasOtherDepartment || input.value === mainDepartment?.value;
    if (input.disabled) {
      input.checked = false;
    }
  }
}

function syncPasswordConfirmation(form) {
  const confirmation = form.querySelector("#sign_up_confirm_pwd");
  confirmation.setCustomValidity(confirmation.value && confirmation.value !== form.querySelector("#sign_up_pwd").value ?
    "Les deux mots de passe saisis ne sont pas identiques" : "");
}

export function checkSignUpForm(form) {
  syncDepartments(form);
  syncPasswordConfirmation(form);
  form.classList.add("checked");
  const valid = displayErrors(form);
  if (!valid) {
    form.querySelector(".form_errors").scrollIntoView({block: "nearest", behavior: "smooth"});
  }
  return valid;
}

export function refreshSignUpForm(form) {
  syncDepartments(form);
  syncPasswordConfirmation(form);
  if (form.classList.contains("checked")) {
    displayErrors(form);
  }
}
